<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="4" md="2" lg="2">
      <FilterSearch
        :fetchData="fetchRecharges"
        searchTerm="code"
        label="code"
        type="number"
      />
    </v-col>
    <v-col cols="12" sm="8" md="3" lg="2">
      <FilterSelect
        :fetchData="fetchRecharges"
        :items="[
          { label: $t(`recharge.status.PENDING`), value: 'PENDING' },
          { label: $t(`recharge.status.RECEIVED`), value: 'RECEIVED' },
          { label: $t(`recharge.status.CONFIRMED`), value: 'CONFIRMED' },
          { label: $t(`recharge.status.OVERDUE`), value: 'OVERDUE' },
        ]"
        item-text="label"
        item-value="value"
        type="status"
        label="Status"
      />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchRecharges" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDates from '@/components/filters/FilterDates'
import FilterSelect from '@/components/filters/FilterSelect'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RechargeListFilters',

  components: { FilterSelect, FilterSearch, FilterDates },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchRecharges']),
  },
}
</script>
